import dayjs from "dayjs";

/**
 * Formats a date string or object to the given dayjs format
 * @param date
 * @param format
 */
export const formatDate = (date: string | Date, format: string) =>
  dayjs(new Date(date)).format(format);
